<template>
	<div>
		<h4
			:class="question.Value.LabelType"
			v-if="question.Value.LabelType === 'Header'"
			class="label-header"
			:data-title="question.Value.Description"
		>
			{{question.Value.Description}}
			<info-text :info-text="question.Value.ToolTipText"></info-text>
		</h4>
		<p :class="question.Value.LabelType" v-else class="label-info mb0">
			{{question.Value.Description}}
			<info-text :info-text="question.Value.ToolTipText"></info-text>
		</p>
	</div>
</template>

<script>
import InfoText from '@/partials/InfoText';

export default {
	components: { InfoText },
	props: ['question']
};
</script>

<style>
label.Header {
	color: #574689;
	font-size: 1.5em;
	margin: 15px 0 10px;
}

label.Info {
	color: #000;
	font-size: 12px;
}

label.Warning {
	color: #ffa125;
	font-size: 1.1em;
	margin: 15px 0 10px;
}
</style>
